import moment from 'moment';
import { isLAP, isAPD, isTU, isGGI } from '../../actions/root_url';

export function dateFormat(format, date) {
  return (date) ?
    moment(date).format(format || 'YYYY-MM-DD') :
    moment().format(format || 'YYYY-MM-DD');
}

export function maxDate(format) {
  return moment('3000-01-01').format(format || 'YYYY-MM-DD');
}

export function minDate(format) {
  return moment('1900-01-01').format(format || 'YYYY-MM-DD');
}

export function maxDateUtc() {
  return moment('3000-01-01').endOf('day').toISOString();
}

export function minDateUtc() {
  return moment('1900-01-01').startOf('day').toISOString();
}

export function convertUtcDate(date) {
  return (date) ? moment(date).toISOString() : moment().toISOString();
}

export const newDate = (time) => {
  var date = new Date(time)
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  var d = date.getDate()
  d = d < 10 ? '0' + d : d
  var h = date.getHours()
  h = h < 10 ? '0' + h : h
  var minute = date.getMinutes()
  minute = minute < 10 ? '0' + minute : minute
  var s = date.getSeconds()
  s = s < 10 ? '0' + s : s
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
}


export function convertLocalDate(date, format) {
  return (date) ?
    moment(date).local().format(format || 'YYYY-MM-DD') :
    moment().local().format(format || 'YYYY-MM-DD');
}

export function getDateRangeBetweenDates(monthsAway) {
  let startOfMonth;
  const days = {};
  days.lastMonth = false;
  if (monthsAway === -1 || monthsAway === '-1') {
    days.days = '-1';
  } else {
    const today = moment();
    if (parseInt(monthsAway) > 1) {
      startOfMonth = moment().subtract(monthsAway - 1, 'months').startOf('month');
      days.days = today.diff(startOfMonth, 'days');
    } else if (monthsAway === 1 || monthsAway === '1') {
      startOfMonth = moment().subtract(1, 'month').startOf('month');
      const endOfMonth = moment().subtract(1, 'month').endOf('month');
      days.days = endOfMonth.diff(startOfMonth, 'days');
      days.lastMonth = true;
    } else if (monthsAway === 0 || monthsAway === '0') {
      startOfMonth = moment().startOf('month');
      days.days = today.diff(startOfMonth, 'days');
    }
  }
  return days;
}

export function grabMonthsToAndFromDates(days, fromDate, toDate, lastMonth) {
  let dateRange = -1;
  if (days != null) { dateRange = days; }
  const date = {
    fromDate: '',
    toDate: '',
  };
  let dateGT = '';
  let dateLT = '';
  dateGT = (fromDate) ? moment(fromDate).startOf('day').toISOString() : minDateUtc();
  dateLT = (toDate) ? moment(toDate).endOf('day').toISOString() : maxDateUtc();
  if (!(dateRange === '-1' || dateRange === -1)) {
    dateLT = moment().endOf('day').toISOString();
    dateGT = moment(dateLT).startOf('day').subtract(days, 'days').toISOString();
  }
  if (lastMonth) {
    dateGT = moment().subtract(1, 'month').startOf('month');
    dateLT = moment(dateGT).endOf('month').subtract(1, 'day');
    dateGT = dateGT.toISOString();
    dateLT = dateLT.toISOString();
  }
  date.fromDate = dateGT;
  date.toDate = dateLT;
  return date;
}

export function toFromDates(days, fromDate, toDate, format, isOffset = false) {
  let dateRange = -1;
  if (days != null) { dateRange = days; }
  const date = {
    fromDate: '',
    toDate: '',
  };
  let dateGT = '';
  let dateLT = '';
  if((isLAP || isAPD) && days == '-2') {
    return {
      fromDate: minDateUtc(),
      toDate: maxDateUtc(),
    }
  }
  if (format) {
    if (!(dateRange === '-1' || dateRange === -1)) {
      dateLT = moment().local().endOf('day').format(format);
      if (dateRange === '1' || dateRange === 1) {
        dateGT = moment().local().startOf('day').format(format);
      } else if (dateRange === '7' || dateRange === 7) {
        dateGT = moment(dateLT).local().subtract('7', 'days').startOf('day').format(format);
      } else if (dateRange === '30' || dateRange === 30) {
        dateGT = moment(dateLT).local().subtract('30', 'days').startOf('day').format(format);
      } else if (dateRange === '90' || dateRange === 90) {
        dateGT = moment(dateLT).local().subtract('90', 'days').startOf('day').format(format);
      }
    }
  } else {
    if(isLAP || isAPD) {
      dateGT = (fromDate) ? moment(fromDate).startOf('day').toISOString() : minDateUtc();
    } else {
      if(isTU || isGGI) {
        dateGT = (fromDate) ? moment(fromDate).startOf('day').toISOString(isOffset) : minDateUtc();
      } else {
        dateGT = (fromDate) ? moment(fromDate).startOf('day').toISOString() : minDateUtc();
      }
    }
    if(isTU || isGGI) {
      dateLT = (toDate) ? moment(toDate).endOf('day').toISOString(isOffset) : maxDateUtc();
    } else {
      dateLT = (toDate) ? moment(toDate).endOf('day').toISOString() : maxDateUtc();
    }
    
    if (!(dateRange === '-1' || dateRange === -1)) {
      dateLT = moment().endOf('day').toISOString();
      if (dateRange === '1' || dateRange === 1) {
        dateGT = moment().startOf('day').toISOString();
      } else if (dateRange === '7' || dateRange === 7) {
        dateGT = moment(dateLT).startOf('day').subtract('6', 'days').toISOString();
      } else if (dateRange === '30' || dateRange === 30) {
        dateGT = moment(dateLT).startOf('day').subtract('29', 'days').toISOString();
      } else if (dateRange === '60' || dateRange === 60) {
        dateGT = moment(dateLT).startOf('day').subtract('59', 'days').toISOString();
      } else if (dateRange === '90' || dateRange === 90) {
        dateGT = moment(dateLT).startOf('day').subtract('89', 'days').toISOString();
      } else {
        dateGT = moment(dateLT).startOf('day').subtract(days, 'days').toISOString();
      }
    }
  }
  date.fromDate = dateGT;
  date.toDate = dateLT;
  return date;
}


export function toFromDispatchDates(days, dispatchDateLT, dispatchDateGT, format) {
  let dateRange = -1;
  if (days != null) { dateRange = days; }
  const date = {
    dispatchDateLT: '',
    dispatchDateGT: '',
  };
  let dateLT = '';
  let dateGT = '';
  if (format) {
    dateGT = (dispatchDateGT) ? moment(dispatchDateGT).startOf('day').toISOString() : minDateUtc();
    dateLT = (dispatchDateLT) ? moment(dispatchDateLT).endOf('day').toISOString() : maxDateUtc();
    if (!(dateRange === '-1' || dateRange === -1)) {
      dateLT = moment().local().endOf('day').format(format);
      if (dateRange === '1' || dateRange === 1) {
        dateGT = moment().local().startOf('day').format(format);
      } else if (dateRange === '7' || dateRange === 7) {
        dateGT = moment(dateLT).local().subtract('7', 'days').startOf('day').format(format);
      } else if (dateRange === '30' || dateRange === 30) {
        dateGT = moment(dateLT).local().subtract('30', 'days').startOf('day').format(format);
      } else if (dateRange === '90' || dateRange === 90) {
        dateGT = moment(dateLT).local().subtract('90', 'days').startOf('day').format(format);
      } else if (dateRange === '-2' || dateRange === -2) {
        dateGT = moment(dateLT).local().add('2', 'days').startOf('day').format(format);
      } else if (dateRange === '-7' || dateRange === -7) {
        dateGT = moment(dateLT).local().add('7', 'days').startOf('day').format(format);
      }
    }
  } else {
    dateGT = (dispatchDateLT) ? moment(dispatchDateLT).startOf('day').toISOString() : minDateUtc();
    dateLT = (dispatchDateGT) ? moment(dispatchDateGT).endOf('day').toISOString() : maxDateUtc();
    if (!(dateRange === '-1' || dateRange === -1)) {
      dateLT = moment().endOf('day').toISOString();
      if (dateRange === '1' || dateRange === 1) {
        dateGT = moment().startOf('day').toISOString();
      } else if (dateRange === '7' || dateRange === 7) {
        dateGT = moment(dateLT).startOf('day').subtract('6', 'days').toISOString();
      } else if (dateRange === '30' || dateRange === 30) {
        dateGT = moment(dateLT).startOf('day').subtract('29', 'days').toISOString();
      } else if (dateRange === '90' || dateRange === 90) {
        dateGT = moment(dateLT).startOf('day').subtract('89', 'days').toISOString();
      } else if (dateRange === '-2' || dateRange === -2) {
        dateGT = moment(dateLT).startOf('day').add('2', 'days').toISOString();
      } else if (dateRange === '-7' || dateRange === -7) {
        dateGT = moment(dateLT).startOf('day').add('7', 'days').toISOString();
      }
    }
  }
  
  if (dateRange === '-7' || dateRange === -7 || dateRange === '-2' || dateRange === -2) {
    date.dispatchDateGT = dateLT;
    date.dispatchDateLT = dateGT;
  } else {
    date.dispatchDateGT = dateGT;
    date.dispatchDateLT = dateLT;
  }
  
  return date;
}

/*
* @unit definition, default value = 'day'
* 'year'    // set to January 1st, 12:00 am this year
* 'month'   // set to the first of this month, 12:00 am
* 'quarter'  // set to the beginning of the current quarter, 1st day of months, 12:00 am
* 'week'    // set to the first day of this week, 12:00 am
* 'isoWeek' // set to the first day of this week according to ISO 8601, 12:00 am
* 'day'     // set to 12:00 am today
* 'date'     // set to 12:00 am today
* 'hour'    // set to now, but with 0 mins, 0 secs, and 0 ms
* 'minute'  // set to now, but with 0 seconds and 0 milliseconds
* 'second'  // same as moment().milliseconds(0);
*/
export function getFromToDates(date, unit = 'day') {
  if (date) {
    return {
      fromDate: convertUtcDate(moment(date).startOf(unit)),
      toDate: convertUtcDate(moment(date).endOf(unit)),
    };
  }
  return {};
}

export function getFromToDatesWithFilter({ FromDate, ToDate, Year, Quarter, Month }) {
  let fromDate = FromDate ? (moment(FromDate).startOf('day')).toISOString() : minDateUtc();
  let toDate = ToDate ? (moment(ToDate).endOf('day')).toISOString() : maxDateUtc();
  if (Year) {
    if (Month) {
      // Moment month is 0 based
      fromDate = moment([Year.value, Month.value - 1]);
      toDate = moment(fromDate).endOf('month');
    } else if (Quarter) {
      // Starting month: 1 -> 0, 2 -> 3, 3 -> 6, 4 -> 9
      fromDate = moment([Year.value, (Quarter.value - 1) * 3]);
      // Ending month: 1 -> 2, 2 -> 5, 3 -> 8, 4 -> 11
      toDate = moment([Year.value, (Quarter.value * 3) - 1]).endOf('month');
    } else {
      // Moment month is 0 based
      fromDate = moment().startOf('year');
      toDate = moment().endOf('year');
    }
    fromDate = fromDate.toISOString();
    toDate = toDate.toISOString();
  }
  return { fromDate, toDate };
}

/**
 *
 * @param {Number} hours
 * @param {Date} date
 * @returns An ISOString of the specified date and hours in UTC
 */
export function convertTimeToUtc(hours, date) {
  return (
    moment(date)
      .startOf('day')
      .add(hours, 'hours')
      .toISOString()
  );
}
function formatFunc(str) {    //格式化显示
  return str > 9 ? str : '0' + str
}

export function converTimeUTCToLocal(utcTime) {
  if(!utcTime) {
    return utcTime;
  }
  var date2 = new Date(utcTime);
  var year = date2.getFullYear();
  var mon = formatFunc(date2.getMonth() + 1);
  var day = formatFunc(date2.getDate());
  var hour = date2.getHours();
  hour = hour>=12?hour-12:hour;
  hour = formatFunc(hour);
  var min = formatFunc(date2.getMinutes());
  var dateStr = year+'-'+ mon+'-'+day;
  return dateStr;
}

export function isGGiOver(status, date) {// SaleStatus
  if(status != 'Open' && status != 'Quote' && status != 'Packing' && status != 'Pending') {
    return false;
  }
  let utc = moment().utc().format(); // 当前utc
  let t = moment(utc).isAfter(moment(date)); // 当前超出 订单eta 变色
  return t
}

export const timeTOYmdOrMdy = (time) => {
  let timeTo = time;
  if (time.length != 10 || time.indexOf('-') == -1) {
    return timeTo
  }
  // 12-12-2024 -> 2024-12-12
  let times = time.split('-');
  if(times[2].length != 4) {
    return timeTo;
  }
  timeTo = `${times[2]}-${times[0]}-${times[1]}`
  return timeTo;
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/cleanDates.jsx